import qs from 'qs';
import { fetchApi, getUserId } from 'shared/functions';

export const fetchInstrumentDocuments = ({ instrumentId, page, limit = 200 }) => {
  const userId = getUserId();

  const params = {
    page,
    limit,
  };

  const resourceUrl = `/storefront/users/${userId}/issues/${instrumentId}/documents?${qs.stringify(
    params,
  )}`;

  return fetchApi(resourceUrl).then(response => response.json());
};

export const fetchInstrumentProducts = async ({ instrumentId }) => {
  const userId = getUserId();

  return fetchApi(`/storefront/users/${userId}/issues/${instrumentId}/products`).then(response =>
    response.json(),
  );
};

export const fetchInstruments = async ({ query, limit, page, sort, filter }) => {
  const params = {
    query,
    page,
    limit,
    ...(sort && { sort: sort.sortColumn }),
    ...(sort && { dir: sort.direction }),
  };

  const filters = { ...filter };
  if (!Array.isArray(filter.countries) || !filter.countries.length) {
    delete filters.countries;
  }

  const filterString = filters ? `&filter=${encodeURI(JSON.stringify(filters))}` : '';

  return fetchApi(`/storefront/issues?${qs.stringify(params)}${filterString}`).then(response =>
    response.json(),
  );
};

export const fetchInstrument = async ({ id }) => {
  const instrumentApiData = fetchApi(`/storefront/issues/${id}`).then(response => response.json());

  const productsApiData = fetchInstrumentProducts({ instrumentId: id });

  const documentsApiData = fetchInstrumentDocuments({ instrumentId: id, page: 1, limit: 25 });

  return {
    instrumentApiData: await instrumentApiData,
    documentsApiData: await documentsApiData,
    productsApiData: await productsApiData,
  };
};
